import React, { FC, useState, useEffect, useMemo, useRef } from 'react';
import { TGDPRConsentField, TGDPRPopupModalPolicyFieldState } from '../../../../types/gdprConsentField.types';
import { windowService } from '../../../../../../utils/window.utils';
import GdprPolicyConsent from './components/gdprPolicyConsent';

const GdprInlineConsent: FC<TGDPRConsentField> = (props) => {
    const { field, errors } = props;
    const hasAnyError = !!errors?.length;
    const FieldValidationErrors = props.fieldValidationErrorsComponent;
    const id = field.valueField.id;
    const name = field.valueField.name;
    const gdprPolicies = field?.model?.gdprPolicies;
    const initialValue = JSON.stringify({isFormOverlay: true, validationPassed: false});
    const [value, setValue] = useState(initialValue);
    const initialPolicies = useRef<TGDPRPopupModalPolicyFieldState | undefined>(
      gdprPolicies
        ? gdprPolicies.policies?.map((policy) => ({
            id: policy.id,
            accepted: undefined,
            required: policy.required,
            type: policy.type,
          }))
        : undefined
    );

    const [data, setData] = useState<TGDPRPopupModalPolicyFieldState | undefined>(initialPolicies.current);
    const isAllRadioDisagreed = !!data?.every((item) =>
        item.type === 'radio' ? item.accepted === false || item.accepted === undefined : true
    );
    const contactChecboxes = useMemo(() => (gdprPolicies?.policies.filter((policy) => policy.type === 'checkbox_contacts') || []), [props]);
    const contactConsentDescriptionIndex = useMemo(
        () =>
            contactChecboxes.length
                ? gdprPolicies?.policies?.findIndex(
                    (policy, i) => policy.type === 'checkbox' && gdprPolicies.policies[i + 1]?.type === 'checkbox_contacts'
                )
                : undefined,
        [props]
    );

    const encodeValue = (rawValue: string): string => windowService()?.btoa(rawValue);

    useEffect(() => {
        if (value == initialValue || !props?.value) {
          // resting values after submission
          if (!props.value && value != initialValue) {
            setData(initialPolicies.current);
            setValue(initialValue);
          }
          props.onChange(field.valueField.name, encodeValue(initialValue), props.isValid, []);
        } else {
          props.onChange(field.valueField.name, encodeValue(value), props.isValid, []);
        }
      }, [value, props?.value]);

    const updateData = (id: number, value: boolean) => {
        const updatedData = data?.map((item) => {
            if (item.id === id) return { ...item, id, accepted: value };
            return item;
        });
        setData(updatedData);

        // check for validation passed or failed
        const isAnyRadioButtonNotAccepted = !!updatedData?.find((item) => item.type === 'radio' && item.accepted === undefined);
        const isAnyContactChecked = !!updatedData?.find((item) => item.type === 'checkbox_contacts' && item.accepted === true);
        const otherFiledsCheckStatus = updatedData?.every((item, ind) => {
                    if (item.type == 'checkbox_contacts' || ind == contactConsentDescriptionIndex) {
                      return true;
                    } else return item.required ? item.accepted : true;
                  });
        const validationPassed = otherFiledsCheckStatus &&
                (contactChecboxes?.length == 0 || isAllRadioDisagreed ? true : isAnyContactChecked) &&
                !isAnyRadioButtonNotAccepted;
        setValue(JSON.stringify({
            isFormOverlay: true,
            validationPassed,
            version: gdprPolicies?.version,
            policies: updatedData?.map(({ id, accepted, type }) =>
                type === 'checkbox_contacts' && isAllRadioDisagreed ? { id, accepted: false } : { id, accepted: accepted || false }
            ),
        }))
    };

    return (
        <>
            {(gdprPolicies && data) && <div className={`${hasAnyError ? 'sitecore-jss-form__control--has-error' : ''}`}>
                <input
                    id={id}
                    name={name}
                    className="sitecore-jss-form__field sitecore-jss-form__field--gdpr"
                    type="hidden"
                    value={value}
                    form="novalidatedform"
                />
                <GdprPolicyConsent
                    data={data}
                    gdprPolicies={gdprPolicies}
                    updateData={updateData}
                    contactChecboxes={contactChecboxes}
                />
            </div>}
            {FieldValidationErrors && <FieldValidationErrors {...props} />}
        </>
    )
}

export default GdprInlineConsent;
